<script setup lang="ts">
    import { ref } from "vue";
    import KDialog from "@/components/generic/KDialog.vue";
    import KForm from "@/components/forms/Form/KForm.vue";

    defineProps<{
        errors: Record<string, string[]> | {};
    }>();

    const emit = defineEmits<{
        (e: "acceptResurskrock"): void;
    }>();

    const acceptText = "Acceptera resurskrock";
    const cancelContent = "Avbryt";

    const dialogRef = ref<InstanceType<typeof KDialog>>();

    const showDialog = () => {
        dialogRef.value?.show();
    };

    defineExpose({
        show: showDialog,
        hide: () => dialogRef.value?.hide(),
    });
</script>
<template>
    <KDialog
        ref="dialogRef"
        variant="warning"
        :accept-content="acceptText"
        :cancel-content="cancelContent"
        :accept-action="() => emit('acceptResurskrock')"
        cancel-size="primary"
    >
        <template #default>
            <ul v-if="Object.keys(errors).length > 0" class="error-messages form-content">
                <!-- FIXME: i vue 3, sätt :key på template -->
                <template v-for="(fieldMessages, field) in errors">
                    <li
                        v-for="(message, index) in fieldMessages"
                        :key="`${field}-error-${index}`"
                        class="message span-all"
                    >
                        <p>{{ message }}</p>
                    </li>
                </template>
            </ul>
        </template>
    </KDialog>
</template>
<style lang="scss" scoped>
    @import "@/style/_variables.scss";

    .error-messages {
        list-style-type: none;
        padding-inline-start: 0;
        margin-bottom: 0;
    }

    .message p {
        color: $color-text-popup;
        font-size: 28px;
        font-weight: 500;
        line-height: 31px;
    }
</style>
